export default {
	newsContainer: '.news-container'
};
